import { ROLE_SUPERADMIN, ROLE_PARTNER_ADMIN } from '../../constants/roles';
import { createHasPricerAccessSelector } from '../session';

export const selectCanAccessPricer = createHasPricerAccessSelector([ROLE_SUPERADMIN]);